import { R as React } from './injectIntl-6b03af4d.js';
import { a as getIsRunningInChromatic } from './chromatic-b6cfde84.js';
import { s as styled } from './styled-a7735015.js';
import { B as Button } from './Button-e4e436ac.js';
import { C as CircularProgress } from './CircularProgress-4a7bdab3.js';

/** @jsx React.createElement */
const variantToProps = {
    primary: { variant: 'contained' },
    secondary: {
        variant: 'outlined',
        sx: { background: 'transparent' },
    },
    destructive: { className: 'warning' },
    tertiary: {},
    text: {
        variant: 'text',
        sx: { background: 'transparent' },
    },
    'text-foreground': {
        variant: 'text',
        sx: { color: 'var(--color-foreground)' },
    },
};
function joinClasses(...classes) {
    return classes.filter(Boolean).join(' ');
}
const ApButtonReact = React.forwardRef((props, ref) => {
    const { startIcon, endIcon, variant = 'primary', size = 'tall', label, type = 'button', disabled = false, loading = false, onClick, href, tabIndex, onMouseEnter, onMouseLeave, onFocus, onBlur, } = props;
    const hasStartIcon = !!startIcon;
    const hasEndIcon = !!endIcon;
    const shouldShowLoadingAsStartIcon = loading && hasStartIcon;
    const shouldShowLoadingAsEndIcon = loading && !hasStartIcon && hasEndIcon;
    const shouldShowLoadingAsLabel = loading && !hasStartIcon && !hasEndIcon;
    const variantProps = variantToProps[variant];
    const loadingIndicator = loading ? React.createElement(ButtonLoadingIndicator, { "aria-label": label }) : null;
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledButton, Object.assign({ ref: ref, type: type, color: "secondary" }, (disabled ? { disabled: true } : {}), { disableElevation: true, onClick: !loading ? onClick : undefined, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onFocus: onFocus, onBlur: onBlur, startIcon: (loading && shouldShowLoadingAsStartIcon) ? loadingIndicator : startIcon, endIcon: (loading && shouldShowLoadingAsEndIcon) ? loadingIndicator : endIcon }, variantProps, { tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : (loading ? -1 : undefined), "aria-disabled": (disabled || loading) ? 'true' : undefined, className: joinClasses(variantProps === null || variantProps === void 0 ? void 0 : variantProps.className, loading && 'loading'), href: href, customSize: size }),
            React.createElement("span", { className: shouldShowLoadingAsLabel ? 'hide-but-keep-taking-space' : undefined }, label),
            shouldShowLoadingAsLabel && (React.createElement("div", { className: "label-loading-indicator-container" }, loadingIndicator))),
        loading && React.createElement("div", { className: "loading-mouse-interactions-blocker", tabIndex: 0 })));
});
const StyledButton = styled(Button, { shouldForwardProp: (prop) => prop !== 'customSize' })(({ theme, customSize, }) => ({
    '--border-radius': `3px`,
    '--focus-border-offset': `1px`,
    '--focus-border-width': `2px`,
    // Automatically calculate the outer focus border radius and position
    '--focus-border-radius': `calc( var(--border-radius) + var(--focus-border-offset) + var(--focus-border-width) )`,
    '--focus-border-inset': `calc( -1 * (var(--focus-border-offset) + var(--focus-border-width) + 1px))`,
    position: 'relative',
    borderRadius: 'var(--border-radius)',
    minWidth: '120px',
    height: customSize === 'tall' ? '40px' : '32px',
    '&.loading': { pointerEvents: 'none' },
    ':before': {
        content: `''`,
        boxSizing: 'border-box',
        position: 'absolute',
        inset: `var(--focus-border-inset)`,
        border: `var(--focus-border-width) solid ${theme.palette.semantic.colorFocusIndicator}`,
        borderRadius: 'var(--focus-border-radius)',
        pointerEvents: 'none',
        display: 'none',
    },
    ':focus-visible': {
        outline: 'none',
        ':before': { display: 'block' },
    },
}));
const LOADING_INDICATOR_CLASSES = {
    root: 'loading-indicator-root',
    svg: 'loading-indicator-svg',
};
function ButtonLoadingIndicator(props) {
    const isRunningInChromatic = getIsRunningInChromatic();
    return (React.createElement(CircularProgress, Object.assign({ size: 16 }, props, { classes: LOADING_INDICATOR_CLASSES, className: joinClasses(props.className, isRunningInChromatic && 'disable-animations-for-chromatic') })));
}

export { ApButtonReact as A };

//# sourceMappingURL=ap-button.react-13b96138.js.map